import type { PastEvent } from "../types";

/** Memòria de les primeres activitats de Cosa Nova, en ordre cronològic invers. */
export const pastEvents: PastEvent[] = [
	{
		id: "cartografia-presentacions",
		title: "Presentació de Cartografia de l’estrany",
		date: "21 i 28 de març de 2026",
		category: "Presentació",
		description:
			"Dues trobades al voltant del primer mapa de l’antologia, amb les autores i els autors, música en viu i un brindis compartit.",
		venue: "Sala Meifrèn · Cadaqués",
		image: "/assets/cartografia-presentacio.jpg",
		imageAlt: "Cartell de la presentació de Cartografia de l’estrany",
		href: "/presentacio-antologia-cartografia-de-lestrany-mapa-i-finestres/",
		featured: true,
	},
	{
		id: "aperitiu-editorial",
		title: "Aperitiu de presentació de l’editorial",
		date: "22 de novembre de 2025",
		category: "Trobada",
		description:
			"La primera trobada pública de Cosa Nova: una invitació a conèixer el projecte i començar a fer comunitat.",
		venue: "Ateneu l’Amistat · Cadaqués",
		image: "/assets/un_ecosistema_literari_mediterrani_1x.webp",
		imageAlt: "Peça gràfica de l’ecosistema literari mediterrani de Cosa Nova",
	},
	{
		id: "taller-escriure-canvi",
		title: "Escriure el canvi",
		date: "22 de novembre de 2025",
		category: "Taller d’escriptura",
		description:
			"Un taller sobre el poder transformador del canvi en la literatura, d’Ovidi fins a Rodoreda.",
		venue: "Sala Meifrèn · Cadaqués",
		image: "/assets/brandguide-1.webp",
		imageAlt: "Composició gràfica de Cosa Nova en blau i blanc",
	},
	{
		id: "microteatre",
		title: "Marieta / Ensenya-me’n",
		date: "22 de novembre de 2025",
		category: "Microteatre",
		description:
			"Dues peces breus de l’Escola de Teatre Arsènic i la Fàbrica de les Arts Roca Umbert de Granollers.",
		venue: "Ateneu l’Amistat · Cadaqués",
		image: "/assets/cadaques-vista-nocturna-esglesia-santa-maria-mar.webp.webp",
		imageAlt: "Cadaqués de nit amb l’església de Santa Maria il·luminada",
	},
];
